import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  flex-direction: column;
`;

export const Title = styled.div`
  font-family: IBMPlexSans;
  font-size: 32px;
  font-weight: 700;
  line-height: 150%;
  margin-top: 38px;
  margin-bottom: 30px;
  padding: 0 20px;
  color: #000;
  text-align: center;

  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 0 15px;
    font-size: 18px;
    text-align: center;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  margin-top: 100px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 50px;
  }
`;


export const Photo = styled.img`
  height: 100px;
`;

export const SquarePhotoDescription = styled.span`
  font-family: IBMPlexSans;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #000;
  text-align: center;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 22.5%;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 32px;
  padding: 50px 17px;

  @media screen and (max-width: 767px) {
    margin-bottom: 40px;
    width: 100%;
    max-width: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
`;

export const TopicWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 130px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    jutify-content: center;
    align-items: center;
  }
`;

export const BigPhotoWrapper = styled.div`
  width: 50%;
  text-align: right;

  @media screen and (max-width: 767px) {
    width: 100%;
    text-align: center;
  }
`;

export const BigPhoto = styled.img`
  width: 400px;

  @media screen and (max-width: 767px) {
    width: 80%;
  }
`;

export const Topics = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 70px;

  @media screen and (max-width: 767px) {
    margin-top: 50px;
    padding: 0;
    padding-left: 3%;
    width: 83%;
  }
`;

export const Topic = styled.div`
  font-family: Poppins-Regular;
  font-weight: 400;
  font-size: 24px;
  line-height: 37px;
  color: #000;
  margin-bottom: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (max-width: 767px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const TopicIcon = styled.img`
  height: 36px;

  @media screen and (max-width: 767px) {
    height: 23.5px;
  }
`;

export const IconWrapper = styled.div`
  width: 36px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-right: 30px;
`;
